import type { WebappConfig } from "@color-finder/config";
import { Link } from "@mui/material";
import type { FC } from "react";
import { useAppConfig } from "../../config/app-config";

export interface DocumentationLinkProps {
  document: keyof WebappConfig["documentation"];
  label: string;
}

export const DocumentationLink: FC<DocumentationLinkProps> = ({
  document,
  label,
}) => {
  const [config] = useAppConfig();

  if (!config?.documentation?.enabled) {
    return null;
  }

  return (
    <Link
      underline="hover"
      target="_blank"
      rel="noopener noreferrer"
      href={config.documentation[document] as string}
    >
      {label}
    </Link>
  );
};
